<template>
  <SfButtonBase
    v-bind="$attrs"
    :variant="variant"
    :small="small"
    :inline="inline"
    :disabled="disabled"
    @click="handleClick"
  >
    <slot></slot>
  </SfButtonBase>
</template>
<script setup lang="ts">
import SfButtonBase from './sf-button-base.vue'

// eslint-disable-next-line no-undef
defineOptions({
  name: 'SfButton',
})

interface Props {
  variant?: string
  small?: boolean
  inline?: boolean
  disabled?: boolean
}

withDefaults(defineProps<Props>(), {
  variant: 'primary',
})

const emit = defineEmits(['click'])

function handleClick(): void {
  emit('click')
}
</script>
